import { Step } from '../types';

const getStep = (steps: Record<string, Step>, activeStepIndex: number): Step => {
  const keys = Object.keys(steps);

  return steps[keys[activeStepIndex + 1 > keys.length ? 0 : activeStepIndex]];
};

export default getStep;
